import { InstoreEnrollmentPage } from 'src/components/instore-enrollment';

export default InstoreEnrollmentPage;
